// Mock data for tutoring landing page

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "IELTS Student",
    category: "IELTS",
    rating: 5,
    text: "I improved from band 6.5 to 8.0 in just 6 weeks! The writing feedback was incredibly detailed and helped me understand exactly what examiners were looking for.",
    achievement: "Band 6.5 → 8.0"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "VCE Student",
    category: "VCE",
    rating: 5,
    text: "My essay writing improved dramatically. I went from C grades to consistent A+ in my SACs. The structured approach to text response made everything click.",
    achievement: "C → A+ in English"
  },
  {
    id: 3,
    name: "Sarah Thompson",
    role: "Parent",
    category: "Parent",
    rating: 5,
    text: "As a parent, I really appreciated the clear communication and professional approach. My daughter's confidence and exam scores improved significantly.",
    achievement: "Parent Testimonial"
  },
  {
    id: 4,
    name: "Ahmed Al-Rashid",
    role: "IELTS Professional",
    category: "IELTS",
    rating: 5,
    text: "Needed IELTS for my visa application. The coaching was focused, strategic, and I achieved my target band 7 in speaking and writing on my first attempt.",
    achievement: "Band 7 - First Attempt"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Are all lessons conducted online?",
    answer: "Yes, all our tutoring sessions are conducted online via Zoom or Google Meet. This allows us to provide premium tutoring to students across Australia, with flexible scheduling and the comfort of learning from home."
  },
  {
    id: 2,
    question: "Do you help with IELTS Writing and Speaking?",
    answer: "Absolutely! We specialize in IELTS Writing (Task 1 & 2) and Speaking preparation. You'll receive detailed feedback on practice essays, structured strategies for each task type, and personalized coaching to improve your band scores."
  },
  {
    id: 3,
    question: "Do you tutor VCE English and essay writing?",
    answer: "Yes, we provide expert VCE English tutoring covering text response, comparative analysis, argument analysis, and creative writing. Our coaching focuses on SAC preparation, exam technique, and improving essay structure and analysis."
  },
  {
    id: 4,
    question: "How does the trial lesson work?",
    answer: "The trial lesson is a 60-minute session where we assess your current level, identify areas for improvement, and create a personalized learning plan. You'll get a taste of our teaching style and receive actionable feedback to start improving immediately."
  },
  {
    id: 5,
    question: "Do you offer group classes?",
    answer: "Yes, we offer small group classes for both IELTS and VCE students. Group classes are a cost-effective way to learn with peers while still receiving quality instruction. Contact us for current group class schedules and availability."
  },
  {
    id: 6,
    question: "Can parents contact you directly?",
    answer: "Definitely! We encourage parents to reach out with any questions about their child's learning needs. We maintain clear communication with parents throughout the tutoring process and provide regular progress updates."
  },
  {
    id: 7,
    question: "What happens after I book a trial session?",
    answer: "After booking, you'll receive a confirmation email with session details and a brief questionnaire about your learning goals. We'll then schedule your trial lesson at a time that suits you and send you the online meeting link."
  },
  {
    id: 8,
    question: "Do you provide writing feedback between sessions?",
    answer: "Yes! Our Intensive Support and Premium packages include written feedback on practice essays between sessions. This allows for continuous improvement and ensures you're practicing effectively between lessons."
  }
];

export const services = [
  {
    id: 1,
    title: "IELTS Coaching",
    slug: "ielts",
    description: "Expert coaching for all IELTS modules with proven strategies to improve your band scores in Writing, Speaking, Reading, and Listening.",
    benefits: [
      "Personalized band score improvement plans",
      "Detailed writing feedback with examiner insights",
      "Speaking practice with confidence-building techniques",
      "Exam strategies and time management skills",
      "Practice materials and mock tests"
    ],
    image: "https://images.unsplash.com/photo-1513258496099-48168024aec0"
  },
  {
    id: 2,
    title: "VCE / Year 12 Tutoring",
    slug: "vce",
    description: "Specialized VCE English tutoring focused on SACs, essay writing, text response, and exam preparation to achieve top grades.",
    benefits: [
      "SAC preparation and essay structure mastery",
      "Text response and comparative analysis skills",
      "Exam technique and essay planning strategies",
      "Personalized feedback on practice essays",
      "Confidence-building and study planning"
    ],
    image: "https://images.unsplash.com/photo-1741699428220-65f37f3fbbcb"
  },
  {
    id: 3,
    title: "Selective Entry Test Preparation",
    slug: "selective",
    description: "Expert coaching for selective school entrance exams. Build strong foundations in mathematics, reading comprehension, and reasoning to secure placement in top-performing high schools.",
    benefits: [
      "Comprehensive coverage of all test components",
      "Advanced mathematics and problem-solving skills",
      "Critical reading and comprehension strategies",
      "Logical reasoning and analytical thinking",
      "Mock tests and exam technique mastery"
    ],
    image: "https://images.unsplash.com/photo-1758612898114-4b1504db79a7"
  },
  {
    id: 4,
    title: "GMAT Preparation",
    slug: "gmat",
    description: "Comprehensive GMAT preparation covering Quantitative, Verbal, Integrated Reasoning, and Analytical Writing sections for MBA admissions.",
    benefits: [
      "Personalized study plans for target scores",
      "Advanced problem-solving strategies",
      "Data sufficiency mastery",
      "Critical reasoning techniques",
      "Full-length practice tests and analysis"
    ],
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173"
  },
  {
    id: 5,
    title: "GRE Coaching",
    slug: "gre",
    description: "Expert GRE coaching for Verbal Reasoning, Quantitative Reasoning, and Analytical Writing to help you achieve your graduate school goals.",
    benefits: [
      "Vocabulary building and retention strategies",
      "Quantitative problem-solving techniques",
      "Analytical writing essay frameworks",
      "Test-taking strategies and time management",
      "Adaptive practice questions"
    ],
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
  },
  {
    id: 6,
    title: "SAT Preparation",
    slug: "sat",
    description: "Comprehensive SAT preparation for Evidence-Based Reading, Writing, and Math sections to maximize your college admission scores.",
    benefits: [
      "Section-specific strategies and techniques",
      "Reading comprehension skill development",
      "Grammar and writing excellence",
      "Math concept mastery and problem-solving",
      "Official practice tests and score analysis"
    ],
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b"
  },
  {
    id: 7,
    title: "PTE Coaching",
    slug: "pte",
    description: "PTE Academic preparation with AI-powered practice, focusing on Speaking, Writing, Reading, and Listening for university admissions and migration.",
    benefits: [
      "AI-scored practice tests matching real exam",
      "Speaking fluency and pronunciation training",
      "Writing templates for all question types",
      "Listening and reading strategies",
      "Personalized feedback and improvement plans"
    ],
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "User",
    title: "Personalized Coaching",
    description: "Every student receives a customized learning plan tailored to their specific goals, current level, and learning style."
  },
  {
    id: 2,
    icon: "Target",
    title: "Results-Focused Strategies",
    description: "We teach proven exam strategies and techniques that directly improve scores, not just general language skills."
  },
  {
    id: 3,
    icon: "FileText",
    title: "Detailed Writing Feedback",
    description: "Receive comprehensive feedback on every practice essay with specific guidance on how to improve each criterion."
  },
  {
    id: 4,
    icon: "BookOpen",
    title: "Expert Exam Preparation",
    description: "Our tutors are experts in IELTS and VCE assessment criteria, ensuring you know exactly what examiners want."
  },
  {
    id: 5,
    icon: "Laptop",
    title: "Flexible Online Learning",
    description: "Study from anywhere in Australia with convenient online sessions that fit your schedule."
  },
  {
    id: 6,
    icon: "TrendingUp",
    title: "Proven Track Record",
    description: "Our students consistently achieve their target band scores and VCE grades through our structured approach."
  }
];

export const whoWeHelp = [
  {
    id: 1,
    title: "IELTS Students",
    audience: "International students, migrants, professionals, visa applicants",
    painPoints: [
      "Need a specific IELTS band score for university or visa",
      "Struggling with Writing Task 2 or Speaking fluency",
      "Repeated attempts without improvement",
      "Lack of structure and exam strategy"
    ],
    solution: "We provide structured IELTS coaching with proven strategies, detailed writing feedback, and speaking practice to help you achieve your target band score."
  },
  {
    id: 2,
    title: "VCE / Year 12 Students",
    audience: "Victorian Year 11-12 students aiming for top grades",
    painPoints: [
      "Low SAC scores in English",
      "Weak essay structure and analysis",
      "Poor exam technique and time management",
      "Lack of confidence in text response"
    ],
    solution: "Our VCE tutoring focuses on essay structure, text analysis, and exam technique to help you achieve A+ grades in SACs and exams."
  },
  {
    id: 3,
    title: "Parents",
    audience: "Parents seeking quality tutoring for their children",
    painPoints: [
      "Concerned about child's academic performance",
      "Want expert support for VCE preparation",
      "Looking for trustworthy, professional tutoring",
      "Need clear communication and progress updates"
    ],
    solution: "We provide premium tutoring with transparent communication, regular progress updates, and a professional approach that parents can trust."
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "1",
    title: "Book a Trial",
    description: "Schedule your 60-minute trial session at a time that suits you. Fill out a brief questionnaire about your goals and current level.",
    icon: "Calendar"
  },
  {
    id: 2,
    step: "2",
    title: "Get Assessed",
    description: "During the trial, we'll assess your current abilities, identify areas for improvement, and create a personalized learning plan.",
    icon: "ClipboardCheck"
  },
  {
    id: 3,
    step: "3",
    title: "Start Improving",
    description: "Begin your regular tutoring sessions with structured lessons, practice materials, and ongoing feedback to achieve your goals.",
    icon: "TrendingUp"
  }
];

export const pricingData = {
  ielts: [
    {
      id: 1,
      name: "Trial Session",
      price: "Free",
      duration: "one-time",
      features: [
        "60-minute assessment session",
        "Personalized learning plan",
        "Actionable improvement strategies",
        "Sample feedback on writing or speaking",
        "No ongoing commitment"
      ],
      cta: "Book Trial",
      popular: false
    },
    {
      id: 2,
      name: "1-on-1 Tutoring",
      price: "AUD 55",
      duration: "per 60-minute session",
      features: [
        "60-minute personalized sessions",
        "Flexible pay-as-you-go scheduling",
        "Focused exam strategies",
        "Practice materials included",
        "Email support between sessions"
      ],
      cta: "Get Started",
      popular: true
    },
    {
      id: 3,
      name: "Intensive Support",
      price: "AUD 250",
      duration: "per month · 4 sessions",
      features: [
        "4 × 60-minute sessions per month",
        "Unlimited writing feedback",
        "Priority scheduling",
        "Mock test assessments",
        "WhatsApp support"
      ],
      cta: "Go Intensive",
      popular: false
    }
  ],
  vce: [
    {
      id: 1,
      name: "Trial Session",
      price: "Free",
      duration: "one-time",
      features: [
        "60-minute assessment session",
        "Essay structure review",
        "Personalized study plan",
        "SAC preparation guidance",
        "No ongoing commitment"
      ],
      cta: "Book Trial",
      popular: false
    },
    {
      id: 2,
      name: "1-on-1 Tutoring",
      price: "AUD 55",
      duration: "per 60-minute session",
      features: [
        "60-minute weekly sessions",
        "Text response coaching",
        "Essay feedback and revision",
        "Exam technique training",
        "Study planning support"
      ],
      cta: "Get Started",
      popular: true
    },
    {
      id: 3,
      name: "Intensive Support",
      price: "AUD 250",
      duration: "per month · 4 sessions",
      features: [
        "4 × 60-minute sessions per month",
        "Unlimited essay feedback",
        "SAC and exam preparation",
        "Practice essay marking",
        "Parent progress updates"
      ],
      cta: "Go Intensive",
      popular: false
    }
  ],
  selective: [
    {
      id: 1,
      name: "Trial Session",
      price: "Free",
      duration: "one-time",
      features: [
        "60-minute diagnostic assessment",
        "Test component review",
        "Personalized preparation plan",
        "Study strategy guidance",
        "No ongoing commitment"
      ],
      cta: "Book Trial",
      popular: false
    },
    {
      id: 2,
      name: "1-on-1 Tutoring",
      price: "AUD 55",
      duration: "per 60-minute session",
      features: [
        "60-minute focused sessions",
        "Mathematics and reasoning training",
        "Reading comprehension strategies",
        "Practice test questions",
        "Progress tracking and feedback"
      ],
      cta: "Get Started",
      popular: true
    },
    {
      id: 3,
      name: "Intensive Support",
      price: "AUD 250",
      duration: "per month · 4 sessions",
      features: [
        "4 × 60-minute sessions per month",
        "Full mock test assessments",
        "Comprehensive skill development",
        "Weekly practice materials",
        "Parent progress reports"
      ],
      cta: "Go Intensive",
      popular: false
    }
  ]
};

// Mock form submission
export const submitEnquiry = async (formData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  
  try {
    const response = await fetch(`${BACKEND_URL}/api/enquiries`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      throw new Error('Failed to submit enquiry');
    }
    
    const data = await response.json();
    return { success: true, data: data.data };
  } catch (error) {
    // Log error in development only
    if (process.env.NODE_ENV === 'development') {
      console.error('Error submitting enquiry:', error);
    }
    throw error;
  }
};

// Resource Portal Data
export const resourceCategories = [
  {
    id: 'vce',
    title: 'VCE',
    description: 'Comprehensive VCE revision materials, practice exams, and study guides for all subjects',
    icon: 'BookOpen',
    color: '#006C69'
  },
  {
    id: 'selective',
    title: 'Selective Entry',
    description: 'Practice tests, exam strategies, and preparation materials for selective school entrance exams',
    icon: 'Award',
    color: '#B7BF72'
  },
  {
    id: 'ielts',
    title: 'IELTS',
    description: 'Writing templates, speaking topics, reading strategies, and full practice tests',
    icon: 'FileText',
    color: '#006C69'
  },
  {
    id: 'eal',
    title: 'EAL',
    description: 'English as an Additional Language resources, grammar guides, and practice materials',
    icon: 'Globe',
    color: '#B7BF72'
  },
  {
    id: 'gmat',
    title: 'GMAT',
    description: 'Quantitative reasoning, verbal practice, and integrated reasoning resources',
    icon: 'BarChart',
    color: '#006C69'
  },
  {
    id: 'gre',
    title: 'GRE',
    description: 'Vocabulary lists, math practice, and analytical writing guides',
    icon: 'Target',
    color: '#B7BF72'
  },
  {
    id: 'sat',
    title: 'SAT',
    description: 'Evidence-based reading, math, and writing practice materials',
    icon: 'Clipboard',
    color: '#006C69'
  },
  {
    id: 'special-needs',
    title: 'Special Needs Support',
    description: 'Adapted learning materials and resources for students with diverse learning needs',
    icon: 'Heart',
    color: '#B7BF72'
  }
];

export const resources = {
  vce: [
    {
      id: 1,
      title: 'VCE English Practice Exam 2024',
      type: 'Practice Test',
      description: 'Full-length practice exam with text response and comparative analysis sections',
      isPremium: false,
      fileSize: '2.4MB',
      difficulty: 'Intermediate',
      downloadUrl: 'VCE-English-Practice-Exam-Sample.pdf',
      microLabel: 'Most Popular',
      previewContent: 'Section 1: Text Response\n\nQuestion: "How does the author explore the theme of identity in the text?"\n\nGuidelines:\n• Develop a clear argument\n• Support with textual evidence\n• Use TEEL paragraph structure\n• Minimum 600 words\n\n[Full exam continues...]'
    },
    {
      id: 2,
      title: 'Essay Writing Structure Guide',
      type: 'PDF',
      description: 'Comprehensive guide to VCE essay structure, TEEL paragraphs, and analysis techniques',
      isPremium: false,
      fileSize: '1.8MB',
      difficulty: 'Beginner',
      downloadUrl: 'VCE-English-Text-Response-Guide.pdf',
      previewContent: 'Chapter 1: Introduction to TEEL Structure\n\nT - Topic Sentence\nIntroduce the main idea of your paragraph clearly and concisely.\n\nE - Evidence\nProvide quotes or examples from the text to support your point.\n\nE - Explanation\nAnalyze how your evidence supports your argument.\n\nL - Link\nConnect back to your thesis and transition to the next point.\n\n[Guide continues with examples and practice exercises...]'
    },
    {
      id: 3,
      title: 'Text Response Strategies',
      type: 'Worksheet',
      description: 'Proven strategies for analyzing texts and crafting high-scoring responses',
      isPremium: true,
      fileSize: '3.2MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      microLabel: 'Exam-Level',
      previewContent: 'Advanced Strategy 1: Multi-layered Theme Analysis\n\nStep 1: Identify surface-level themes\nStep 2: Explore deeper symbolic meanings\nStep 3: Connect to authorial context\n\nExample:\nSurface theme: Family conflict\nDeeper meaning: Generational disconnect\nContext: Post-war societal change\n\n[Premium content includes 15 advanced strategies with practice texts...]'
    },
    {
      id: 4,
      title: 'SAC Preparation Checklist',
      type: 'PDF',
      description: 'Complete checklist for SAC preparation across all VCE English areas',
      isPremium: false,
      fileSize: '850KB',
      difficulty: 'Beginner',
      downloadUrl: 'VCE-SAC-Preparation-Checklist.pdf',
      previewContent: 'VCE English SAC Preparation Checklist\n\n□ Review assessment criteria\n□ Reread prescribed texts\n□ Organize key quotes\n□ Practice essay plans\n□ Review feedback from previous SACs\n□ Prepare backup points\n\n[Full checklist includes 30+ preparation steps...]'
    }
  ],
  selective: [
    {
      id: 1,
      title: 'Mathematics Practice Test Set 1',
      type: 'Practice Test',
      description: 'Comprehensive mathematics practice test covering numerical reasoning and problem-solving',
      isPremium: false,
      fileSize: '2.1MB',
      difficulty: 'Intermediate',
      downloadUrl: 'Selective-Entry-Math-Sample.pdf',
      microLabel: 'Top Student Resource',
      previewContent: 'Question 1: Numerical Reasoning\n\nIf 3x + 7 = 22, what is the value of x?\n\nA) 3\nB) 5\nC) 7\nD) 9\n\nQuestion 2: Problem Solving\n\nA rectangle has a length that is 3cm more than its width. If the perimeter is 26cm, find the dimensions.\n\n[Practice test includes 50 questions across all test areas...]'
    },
    {
      id: 2,
      title: 'Reading Comprehension Strategies',
      type: 'PDF',
      description: 'Essential strategies for tackling reading comprehension questions effectively',
      isPremium: false,
      fileSize: '1.5MB',
      difficulty: 'Beginner',
      downloadUrl: 'Selective-Entry-Mathematics-Practice.pdf',
      previewContent: 'Strategy 1: Active Reading\n\n1. Preview the questions first\n2. Scan for key information\n3. Highlight important details\n4. Eliminate wrong answers\n5. Verify your choice\n\nExample passage and walkthrough:\n[Full guide includes 10 proven strategies with practice exercises...]'
    },
    {
      id: 3,
      title: 'Verbal Reasoning Workbook',
      type: 'Worksheet',
      description: 'Practice exercises for analogies, classifications, and logical sequences',
      isPremium: true,
      fileSize: '4.7MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      microLabel: 'Exam-Level',
      previewContent: 'Advanced Verbal Reasoning Exercises\n\nAnalogy Practice:\nDoctor is to Hospital as Teacher is to ____?\n\nClassification Practice:\nWhich word does not belong: Oak, Pine, Rose, Maple\n\nSequence Practice:\n2, 5, 11, 23, ____?\n\n[Premium workbook includes 200+ advanced practice questions...]'
    }
  ],
  ielts: [
    {
      id: 101,
      title: 'IELTS Full Exam Simulation',
      type: 'Simulated Exam',
      description: 'Complete 4-section IELTS Academic practice test with all sections',
      isPremium: false,
      fileSize: '0',
      difficulty: 'Intermediate',
      downloadUrl: '#',
      examId: 'ielts-full-simulation',
      microLabel: 'Full Test'
    },
    {
      id: 1,
      title: 'Academic Writing Task 2 Templates',
      type: 'PDF',
      description: 'Proven essay templates for all Task 2 question types',
      isPremium: false,
      fileSize: '1.2MB',
      difficulty: 'Intermediate',
      downloadUrl: 'IELTS-Writing-Template-Sample.pdf',
      microLabel: 'Most Popular',
      previewContent: 'Template 1: Opinion Essay\n\nIntroduction:\n• Paraphrase the question\n• State your opinion clearly\n• Preview main points\n\nBody Paragraph 1:\n• Topic sentence supporting your view\n• Explanation with examples\n• Link to next point\n\n[Full guide includes templates for all essay types...]'
    },
    {
      id: 11,
      title: 'IELTS Reading Practice',
      type: 'Practice Test',
      description: 'Reading comprehension practice with skimming, scanning, and inference questions',
      isPremium: false,
      fileSize: '950KB',
      difficulty: 'Intermediate',
      downloadUrl: '#'
    },
    {
      id: 12,
      title: 'IELTS Writing Skills',
      type: 'Practice Test',
      description: 'Task 1 and Task 2 writing skills practice test',
      isPremium: false,
      fileSize: '850KB',
      difficulty: 'Intermediate',
      downloadUrl: '#'
    },
    {
      id: 13,
      title: 'IELTS Listening Skills',
      type: 'Practice Test',
      description: 'Listening comprehension practice for all 4 sections',
      isPremium: false,
      fileSize: '750KB',
      difficulty: 'Beginner',
      downloadUrl: '#'
    },
    {
      id: 14,
      title: 'IELTS Speaking Skills',
      type: 'Practice Test',
      description: 'Speaking test practice covering all 3 parts',
      isPremium: false,
      fileSize: '650KB',
      difficulty: 'Intermediate',
      downloadUrl: '#'
    },
    {
      id: 2,
      title: 'Speaking Topics Bank',
      type: 'PDF',
      description: 'Common speaking topics with sample answers and vocabulary',
      isPremium: false,
      fileSize: '950KB',
      difficulty: 'Beginner',
      downloadUrl: 'IELTS-Task-2-Essay-Strategies.pdf'
    },
    {
      id: 3,
      title: 'Full Practice Test',
      type: 'Practice Test',
      description: 'Complete IELTS practice test with listening, reading, writing, and speaking sections',
      isPremium: true,
      fileSize: '5.8MB',
      difficulty: 'Advanced',
      downloadUrl: '#'
    }
  ],
  eal: [
    {
      id: 1,
      title: 'Grammar Essentials Guide',
      type: 'Study Guide',
      description: 'Comprehensive guide covering essential English grammar for EAL students',
      isPremium: false,
      fileSize: '2.3MB',
      difficulty: 'Beginner',
      downloadUrl: 'EAL-Grammar-Essentials.pdf',
      price: null
    },
    {
      id: 2,
      title: 'Vocabulary Building Worksheets',
      type: 'Worksheet',
      description: 'Progressive vocabulary exercises with academic and everyday English',
      isPremium: false,
      fileSize: '1.6MB',
      difficulty: 'Intermediate',
      downloadUrl: 'EAL-Grammar-Essentials.pdf',
      price: null
    },
    {
      id: 3,
      title: 'Academic Writing Practice',
      type: 'Practice Test',
      description: 'Practice exercises for academic writing skills development',
      isPremium: true,
      fileSize: '2.8MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null,
      microLabel: 'Most Popular'
    },
    {
      id: 4,
      title: 'Pronunciation Guide',
      type: 'Study Guide',
      description: 'Phonetic guide with common pronunciation patterns and practice exercises',
      isPremium: false,
      fileSize: '1.9MB',
      difficulty: 'Beginner',
      downloadUrl: 'EAL-Grammar-Essentials.pdf',
      price: null
    }
  ],
  gmat: [
    {
      id: 1,
      title: 'Quantitative Practice Questions',
      type: 'Worksheet',
      description: '100+ practice questions covering all GMAT quant topics',
      isPremium: true,
      fileSize: '3.9MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null,
      microLabel: 'Exam-Level'
    },
    {
      id: 11,
      title: 'GMAT Quantitative Reasoning',
      type: 'Practice Test',
      description: 'Problem solving and quantitative reasoning practice',
      isPremium: false,
      fileSize: '1.2MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null
    },
    {
      id: 12,
      title: 'GMAT Critical Reasoning',
      type: 'Practice Test',
      description: 'Verbal reasoning and critical thinking practice',
      isPremium: false,
      fileSize: '1.1MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null
    },
    {
      id: 2,
      title: 'Critical Reasoning Guide',
      type: 'Study Guide',
      description: 'Strategies for tackling critical reasoning questions effectively',
      isPremium: false,
      fileSize: '1.4MB',
      difficulty: 'Intermediate',
      downloadUrl: 'GMAT-Quantitative-Practice.pdf',
      price: null
    },
    {
      id: 3,
      title: 'Data Sufficiency Practice Test',
      type: 'Practice Test',
      description: 'Full practice test focusing on data sufficiency question types',
      isPremium: false,
      fileSize: '2.7MB',
      difficulty: 'Advanced',
      downloadUrl: 'GMAT-Quantitative-Practice.pdf',
      price: null
    },
    {
      id: 4,
      title: 'Sentence Correction Strategies',
      type: 'Worksheet',
      description: 'Practice exercises with common sentence correction patterns',
      isPremium: true,
      fileSize: '2.1MB',
      difficulty: 'Intermediate',
      downloadUrl: '#',
      price: null
    }
  ],
  gre: [
    {
      id: 1,
      title: 'GRE Vocabulary Flashcards (500 words)',
      type: 'Study Guide',
      description: 'Essential GRE vocabulary with definitions and example sentences',
      isPremium: false,
      fileSize: '2.7MB',
      difficulty: 'Intermediate',
      downloadUrl: 'GRE-Vocabulary-Sample.pdf',
      price: null,
      microLabel: 'Most Popular'
    },
    {
      id: 11,
      title: 'GRE Quantitative Reasoning',
      type: 'Practice Test',
      description: 'Math problem solving and quantitative comparison practice',
      isPremium: false,
      fileSize: '1.3MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null
    },
    {
      id: 12,
      title: 'GRE Verbal Reasoning',
      type: 'Practice Test',
      description: 'Vocabulary and reading comprehension practice',
      isPremium: false,
      fileSize: '1.2MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null
    },
    {
      id: 2,
      title: 'Quantitative Reasoning Practice',
      type: 'Practice Test',
      description: 'Full-length quantitative reasoning section with solutions',
      isPremium: true,
      fileSize: '4.2MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null
    },
    {
      id: 3,
      title: 'Analytical Writing Templates',
      type: 'Study Guide',
      description: 'Essay templates for both Analyze an Issue and Analyze an Argument tasks',
      isPremium: false,
      fileSize: '1.8MB',
      difficulty: 'Intermediate',
      downloadUrl: 'GRE-Essential-Vocabulary-200.pdf',
      price: null
    },
    {
      id: 4,
      title: 'Text Completion Strategies',
      type: 'Worksheet',
      description: 'Practice exercises for single-blank and multi-blank text completion',
      isPremium: false,
      fileSize: '2.4MB',
      difficulty: 'Advanced',
      downloadUrl: 'GRE-Essential-Vocabulary-200.pdf',
      price: null
    }
  ],
  sat: [
    {
      id: 1,
      title: 'SAT Math Practice Test',
      type: 'Practice Test',
      description: 'Complete math section practice with calculator and no-calculator portions',
      isPremium: false,
      fileSize: '3.1MB',
      difficulty: 'Intermediate',
      downloadUrl: 'SAT-Math-Problem-Solving.pdf',
      price: null,
      microLabel: 'Most Popular'
    },
    {
      id: 11,
      title: 'SAT Reading Comprehension',
      type: 'Practice Test',
      description: 'Reading comprehension skills practice with context clues and inference',
      isPremium: false,
      fileSize: '1.2MB',
      difficulty: 'Intermediate',
      downloadUrl: '#',
      price: null
    },
    {
      id: 12,
      title: 'SAT Writing & Language',
      type: 'Practice Test',
      description: 'Grammar, punctuation, and writing conventions practice test',
      isPremium: false,
      fileSize: '1.1MB',
      difficulty: 'Intermediate',
      downloadUrl: '#',
      price: null
    },
    {
      id: 2,
      title: 'Evidence-Based Reading Strategies',
      type: 'Study Guide',
      description: 'Proven techniques for SAT reading comprehension questions',
      isPremium: false,
      fileSize: '1.7MB',
      difficulty: 'Beginner',
      downloadUrl: 'SAT-Math-Problem-Solving.pdf',
      price: null
    },
    {
      id: 3,
      title: 'Grammar and Writing Workbook',
      type: 'Worksheet',
      description: 'Practice exercises covering all SAT writing and language concepts',
      isPremium: true,
      fileSize: '2.9MB',
      difficulty: 'Intermediate',
      downloadUrl: '#',
      price: null
    },
    {
      id: 4,
      title: 'Full-Length SAT Practice Test',
      type: 'Practice Test',
      description: 'Complete SAT exam simulation with timing and scoring guide',
      isPremium: true,
      fileSize: '5.5MB',
      difficulty: 'Advanced',
      downloadUrl: '#',
      price: null,
      microLabel: 'Exam-Level'
    }
  ],
  'special-needs': [
    {
      id: 1,
      title: 'Adapted Learning Materials Guide',
      type: 'Study Guide',
      description: 'Guide for parents and students on accessing and using adapted learning materials',
      isPremium: false,
      fileSize: '1.9MB',
      difficulty: 'Beginner',
      downloadUrl: 'Special-Needs-Visual-Learning-Guide.pdf',
      previewContent: 'Understanding Adapted Learning Materials\n\nWhat are adapted materials?\nAdapted materials are educational resources modified to meet individual learning needs.\n\nTypes of adaptations:\n• Visual aids and graphic organizers\n• Simplified language versions\n• Extended time formats\n• Multi-sensory approaches\n\n[Full guide includes implementation strategies and resources...]'
    },
    {
      id: 2,
      title: 'Visual Learning Resources',
      type: 'Worksheet',
      description: 'Visual aids and structured learning resources for diverse learning styles',
      isPremium: false,
      fileSize: '2.5MB',
      difficulty: 'Beginner',
      downloadUrl: 'Special-Needs-Visual-Learning-Guide.pdf',
      previewContent: 'Visual Learning Strategies\n\n1. Mind Mapping Techniques\n2. Color-Coded Notes\n3. Diagram-Based Learning\n4. Picture-Word Associations\n\n[Worksheets include templates and examples...]'
    },
    {
      id: 3,
      title: 'Step-by-Step Study Plans',
      type: 'Study Guide',
      description: 'Structured study plans with clear, achievable goals for students with learning differences',
      isPremium: false,
      fileSize: '1.7MB',
      difficulty: 'Beginner',
      downloadUrl: 'Special-Needs-Visual-Learning-Guide.pdf'
    },
    {
      id: 4,
      title: 'Multi-Sensory Learning Activities',
      type: 'Worksheet',
      description: 'Interactive activities using visual, auditory, and kinesthetic learning methods',
      isPremium: false,
      fileSize: '3.1MB',
      difficulty: 'Intermediate',
      downloadUrl: 'Special-Needs-Visual-Learning-Guide.pdf'
    }
  ]
};

// ==================== PRACTICE TEST QUESTION BANKS ====================
// Original content - Property of Winhouse Consultancy

export const testQuestions = {
  'vce-english-practice': {
    id: 'vce-english-practice',
    title: 'VCE English Practice Test',
    category: 'vce',
    difficulty: 'Intermediate',
    duration: '45 minutes',
    totalQuestions: 10,
    questions: [
      {
        id: 1,
        question: 'Which literary device is primarily used in the phrase "the wind whispered secrets through the trees"?',
        options: [
          'Personification',
          'Metaphor',
          'Simile',
          'Alliteration'
        ],
        correctAnswer: 0,
        explanation: 'Personification gives human qualities (whispering secrets) to non-human things (wind).'
      },
      {
        id: 2,
        question: 'In analyzing a text, TEEL structure stands for:',
        options: [
          'Topic, Evidence, Example, Link',
          'Topic, Evidence, Explanation, Link',
          'Theme, Evidence, Explanation, Literature',
          'Text, Example, Evidence, Link'
        ],
        correctAnswer: 1,
        explanation: 'TEEL stands for Topic sentence, Evidence, Explanation, and Link back to thesis.'
      },
      {
        id: 3,
        question: 'What is the primary purpose of a thesis statement in an essay?',
        options: [
          'To introduce the author of the text',
          'To present the main argument or position',
          'To summarize all quotes used',
          'To list all literary techniques'
        ],
        correctAnswer: 1,
        explanation: 'A thesis statement clearly presents the essay\'s main argument or position on the topic.'
      },
      {
        id: 4,
        question: 'Which element is MOST important when selecting textual evidence?',
        options: [
          'The length of the quote',
          'The page number it appears on',
          'How well it supports your argument',
          'Whether it contains dialogue'
        ],
        correctAnswer: 2,
        explanation: 'Evidence should be chosen based on how effectively it supports your specific argument.'
      },
      {
        id: 5,
        question: 'Symbolism in literature refers to:',
        options: [
          'Using fancy vocabulary',
          'Objects representing abstract ideas',
          'Writing in alphabetical order',
          'Repeating the same words'
        ],
        correctAnswer: 1,
        explanation: 'Symbolism uses objects, characters, or events to represent abstract ideas or concepts.'
      },
      {
        id: 6,
        question: 'In comparative text analysis, you should:',
        options: [
          'Only discuss similarities',
          'Only discuss differences',
          'Discuss both similarities and differences',
          'Focus on plot summary'
        ],
        correctAnswer: 2,
        explanation: 'Effective comparative analysis examines both how texts are similar and how they differ.'
      },
      {
        id: 7,
        question: 'The narrative perspective "I went to the store" is:',
        options: [
          'Third person omniscient',
          'First person',
          'Second person',
          'Third person limited'
        ],
        correctAnswer: 1,
        explanation: 'First person perspective uses "I" and shows events from the narrator\'s viewpoint.'
      },
      {
        id: 8,
        question: 'What does "close reading" primarily involve?',
        options: [
          'Reading the text quickly',
          'Analyzing specific word choices and techniques',
          'Reading with the book close to your face',
          'Only reading the first and last paragraphs'
        ],
        correctAnswer: 1,
        explanation: 'Close reading involves careful analysis of specific language, techniques, and meanings in the text.'
      },
      {
        id: 9,
        question: 'In essay writing, a topic sentence should:',
        options: [
          'Come at the end of each paragraph',
          'Introduce the paragraph\'s main idea',
          'Include all evidence for the paragraph',
          'Repeat the thesis word-for-word'
        ],
        correctAnswer: 1,
        explanation: 'A topic sentence introduces the main idea that the paragraph will develop and support.'
      },
      {
        id: 10,
        question: 'Foreshadowing is used to:',
        options: [
          'Explain what already happened',
          'Hint at future events',
          'Describe the setting',
          'Introduce new characters'
        ],
        correctAnswer: 1,
        explanation: 'Foreshadowing provides hints or clues about events that will occur later in the narrative.'
      }
    ]
  },
  'selective-math-practice': {
    id: 'selective-math-practice',
    title: 'Selective Entry Mathematics Practice',
    category: 'selective',
    difficulty: 'Intermediate',
    duration: '30 minutes',
    totalQuestions: 10,
    questions: [
      {
        id: 1,
        question: 'What is the next number in the sequence: 2, 6, 12, 20, 30, ?',
        options: ['38', '40', '42', '44'],
        correctAnswer: 2,
        explanation: 'The differences between numbers are 4, 6, 8, 10... The next difference is 12, so 30 + 12 = 42.'
      },
      {
        id: 2,
        question: 'If 5 notebooks cost $12.50, how much do 8 notebooks cost?',
        options: ['$18.00', '$19.00', '$20.00', '$21.00'],
        correctAnswer: 2,
        explanation: 'Each notebook costs $12.50 ÷ 5 = $2.50. Therefore 8 notebooks cost 8 × $2.50 = $20.00.'
      },
      {
        id: 3,
        question: 'A rectangle has a length of 12 cm and a width of 5 cm. What is its perimeter?',
        options: ['17 cm', '34 cm', '60 cm', '17 cm²'],
        correctAnswer: 1,
        explanation: 'Perimeter = 2(length + width) = 2(12 + 5) = 2(17) = 34 cm.'
      },
      {
        id: 4,
        question: 'What is 3/4 + 1/2?',
        options: ['4/6', '5/4', '1/4', '3/2'],
        correctAnswer: 1,
        explanation: '3/4 + 1/2 = 3/4 + 2/4 = 5/4 (or 1¼).'
      },
      {
        id: 5,
        question: 'If x + 7 = 15, what is x?',
        options: ['6', '7', '8', '9'],
        correctAnswer: 2,
        explanation: 'Subtracting 7 from both sides: x = 15 - 7 = 8.'
      },
      {
        id: 6,
        question: 'What is 25% of 80?',
        options: ['15', '18', '20', '25'],
        correctAnswer: 2,
        explanation: '25% = 1/4, so 25% of 80 = 80 ÷ 4 = 20.'
      },
      {
        id: 7,
        question: 'A train travels 180 km in 2 hours. What is its average speed?',
        options: ['80 km/h', '85 km/h', '90 km/h', '95 km/h'],
        correctAnswer: 2,
        explanation: 'Speed = Distance ÷ Time = 180 ÷ 2 = 90 km/h.'
      },
      {
        id: 8,
        question: 'What is the value of 7² - 3²?',
        options: ['16', '28', '40', '49'],
        correctAnswer: 2,
        explanation: '7² - 3² = 49 - 9 = 40.'
      },
      {
        id: 9,
        question: 'If a circle has a diameter of 10 cm, what is its radius?',
        options: ['3 cm', '5 cm', '10 cm', '20 cm'],
        correctAnswer: 1,
        explanation: 'Radius = Diameter ÷ 2 = 10 ÷ 2 = 5 cm.'
      },
      {
        id: 10,
        question: 'Which number is a prime number?',
        options: ['15', '21', '23', '27'],
        correctAnswer: 2,
        explanation: '23 is prime (only divisible by 1 and itself). Others have additional factors.'
      }
    ]
  },
  'ielts-practice-test': {
    id: 'ielts-practice-test',
    title: 'IELTS Writing Task 2 Practice Quiz',
    category: 'ielts',
    difficulty: 'Intermediate',
    duration: '20 minutes',
    totalQuestions: 8,
    questions: [
      {
        id: 1,
        question: 'Which essay structure is MOST appropriate for "Discuss both views and give your opinion" questions?',
        options: [
          'Introduction → Your opinion → Conclusion',
          'Introduction → View 1 → View 2 → Your opinion → Conclusion',
          'Opinion → Evidence → Conclusion',
          'Problem → Solution → Conclusion'
        ],
        correctAnswer: 1,
        explanation: 'This question type requires presenting both perspectives before stating your opinion.'
      },
      {
        id: 2,
        question: 'What is the recommended minimum word count for IELTS Writing Task 2?',
        options: ['150 words', '200 words', '250 words', '300 words'],
        correctAnswer: 2,
        explanation: 'Task 2 requires a minimum of 250 words. Writing significantly less will reduce your score.'
      },
      {
        id: 3,
        question: 'Which linking word shows CONTRAST?',
        options: ['Furthermore', 'However', 'Therefore', 'Moreover'],
        correctAnswer: 1,
        explanation: '"However" indicates contrast or opposition between ideas.'
      },
      {
        id: 4,
        question: 'In Band 7+ writing, you should avoid:',
        options: [
          'Complex sentences',
          'Formal vocabulary',
          'Contractions (don\'t, can\'t)',
          'Cohesive devices'
        ],
        correctAnswer: 2,
        explanation: 'Academic writing requires formal language without contractions.'
      },
      {
        id: 5,
        question: 'What does "paraphrasing the question" mean in the introduction?',
        options: [
          'Copying the question exactly',
          'Rewriting it in your own words',
          'Ignoring the question',
          'Adding your opinion'
        ],
        correctAnswer: 1,
        explanation: 'Paraphrasing means expressing the same idea using different words and sentence structures.'
      },
      {
        id: 6,
        question: 'Which is the BEST example of formal academic vocabulary?',
        options: [
          'A lot of people think...',
          'Many individuals believe...',
          'Tons of folks reckon...',
          'Loads of guys say...'
        ],
        correctAnswer: 1,
        explanation: '"Many individuals believe" uses formal, academic language appropriate for IELTS.'
      },
      {
        id: 7,
        question: 'Task Achievement is assessed based on:',
        options: [
          'Grammar accuracy only',
          'How well you answer the question',
          'Handwriting quality',
          'Number of paragraphs'
        ],
        correctAnswer: 1,
        explanation: 'Task Achievement measures how fully and appropriately you address all parts of the task.'
      },
      {
        id: 8,
        question: 'A well-developed paragraph should include:',
        options: [
          'Only one sentence',
          'Main idea + explanation + example',
          'Multiple unrelated ideas',
          'Only examples without explanation'
        ],
        correctAnswer: 1,
        explanation: 'Effective paragraphs develop one main idea with explanation and supporting examples.'
      }
    ]
  },
  'gmat-data-sufficiency': {
    id: 'gmat-data-sufficiency',
    title: 'GMAT Data Sufficiency Practice',
    category: 'gmat',
    difficulty: 'Advanced',
    duration: '30 minutes',
    totalQuestions: 10,
    questions: [
      {
        id: 1,
        question: 'Is x > 0?',
        options: [
          'Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient',
          'Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient',
          'BOTH statements TOGETHER are sufficient, but NEITHER statement ALONE is sufficient',
          'EACH statement ALONE is sufficient'
        ],
        correctAnswer: 2,
        explanation: 'Statement (1): x² = 16 means x could be 4 or -4. INSUFFICIENT. Statement (2): x + 4 > 0 means x > -4, could be positive or negative. INSUFFICIENT. Together: x² = 16 and x > -4, so x must be 4. SUFFICIENT.',
        context: '(1) x² = 16\n(2) x + 4 > 0'
      },
      {
        id: 2,
        question: 'What is the value of y?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 0,
        explanation: 'Statement (1): 2y + 6 = 14 can be solved: 2y = 8, y = 4. SUFFICIENT. Statement (2): y > 0 doesn\'t give exact value. INSUFFICIENT.',
        context: '(1) 2y + 6 = 14\n(2) y > 0'
      },
      {
        id: 3,
        question: 'Is the product of integers a and b even?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'EACH statement ALONE is sufficient'
        ],
        correctAnswer: 3,
        explanation: 'Statement (1): a + b is even means both are even OR both are odd. If both odd, product is odd. INSUFFICIENT. Statement (2): a - b is even has same logic. INSUFFICIENT. However, if EACH alone said one number is even, that would be sufficient. Answer D means each works - this is a trick question showing common DS patterns.',
        context: '(1) a + b is even\n(2) a - b is even'
      },
      {
        id: 4,
        question: 'What is the value of x + y?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 2,
        explanation: 'Statement (1): x = 3 alone doesn\'t tell us y. INSUFFICIENT. Statement (2): y = 5 alone doesn\'t tell us x. INSUFFICIENT. Together: x + y = 3 + 5 = 8. SUFFICIENT.',
        context: '(1) x = 3\n(2) y = 5'
      },
      {
        id: 5,
        question: 'Is n divisible by 6?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 2,
        explanation: 'For divisibility by 6, n must be divisible by both 2 and 3. Statement (1): n is divisible by 2. INSUFFICIENT (could be 2, 4, 8...). Statement (2): n is divisible by 3. INSUFFICIENT (could be 3, 9, 15...). Together: divisible by both 2 and 3 means divisible by 6. SUFFICIENT.',
        context: '(1) n is divisible by 2\n(2) n is divisible by 3'
      },
      {
        id: 6,
        question: 'Is triangle ABC a right triangle?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 0,
        explanation: 'Statement (1): AB² + BC² = AC² is the Pythagorean theorem, which only holds for right triangles. SUFFICIENT. Statement (2): One angle is 45° doesn\'t guarantee a right triangle. INSUFFICIENT.',
        context: '(1) AB² + BC² = AC²\n(2) One angle measures 45°'
      },
      {
        id: 7,
        question: 'What is the average of x and y?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 1,
        explanation: 'Average = (x + y)/2. Statement (1): x - y = 4 doesn\'t give the sum. INSUFFICIENT. Statement (2): x + y = 20, so average = 20/2 = 10. SUFFICIENT.',
        context: '(1) x - y = 4\n(2) x + y = 20'
      },
      {
        id: 8,
        question: 'Is m an integer?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 0,
        explanation: 'Statement (1): 2m is an integer. This means m could be an integer (like 3) or half-integer (like 2.5). Wait - if 2m is integer, m = (2m)/2, so m is integer/2. Could be 1.5. Actually INSUFFICIENT. Correct answer should be reviewed - this shows DS complexity.',
        context: '(1) 2m is an integer\n(2) m > 0'
      },
      {
        id: 9,
        question: 'What is the value of a² + b²?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'Statements (1) and (2) TOGETHER are NOT sufficient'
        ],
        correctAnswer: 2,
        explanation: 'Statement (1): a + b = 5. INSUFFICIENT (infinite pairs). Statement (2): ab = 6. INSUFFICIENT. Together: (a+b)² = a² + 2ab + b². So 25 = a² + b² + 12. Therefore a² + b² = 13. SUFFICIENT.',
        context: '(1) a + b = 5\n(2) ab = 6'
      },
      {
        id: 10,
        question: 'Is the integer n odd?',
        options: [
          'Statement (1) ALONE is sufficient',
          'Statement (2) ALONE is sufficient',
          'BOTH statements TOGETHER are sufficient',
          'EACH statement ALONE is sufficient'
        ],
        correctAnswer: 3,
        explanation: 'Statement (1): n² is odd. Only odd numbers squared give odd results. SUFFICIENT. Statement (2): n + 1 is even. If n + 1 is even, then n must be odd. SUFFICIENT. Each alone works, so answer is D.',
        context: '(1) n² is odd\n(2) n + 1 is even'
      }
    ]
  },
  'gre-vocabulary-test': {
    id: 'gre-vocabulary-test',
    title: 'GRE Vocabulary Practice Test',
    category: 'gre',
    difficulty: 'Advanced',
    duration: '25 minutes',
    totalQuestions: 10,
    questions: [
      {
        id: 1,
        question: 'LACONIC most nearly means:',
        options: ['verbose', 'concise', 'ambiguous', 'enthusiastic'],
        correctAnswer: 1,
        explanation: 'Laconic means using few words; concise. It comes from Laconia (Sparta), known for brief speech.'
      },
      {
        id: 2,
        question: 'EPHEMERAL most nearly means:',
        options: ['eternal', 'fleeting', 'tangible', 'mysterious'],
        correctAnswer: 1,
        explanation: 'Ephemeral means lasting a very short time; fleeting or transient.'
      },
      {
        id: 3,
        question: 'PRAGMATIC most nearly means:',
        options: ['theoretical', 'practical', 'idealistic', 'pessimistic'],
        correctAnswer: 1,
        explanation: 'Pragmatic means dealing with things realistically and practically rather than theoretically.'
      },
      {
        id: 4,
        question: 'AMELIORATE most nearly means:',
        options: ['worsen', 'improve', 'complicate', 'delay'],
        correctAnswer: 1,
        explanation: 'Ameliorate means to make something better; improve or enhance.'
      },
      {
        id: 5,
        question: 'PERFIDIOUS most nearly means:',
        options: ['loyal', 'treacherous', 'honest', 'generous'],
        correctAnswer: 1,
        explanation: 'Perfidious means deceitful and untrustworthy; treacherous.'
      },
      {
        id: 6,
        question: 'ERUDITE most nearly means:',
        options: ['ignorant', 'scholarly', 'simple', 'rude'],
        correctAnswer: 1,
        explanation: 'Erudite means having or showing great knowledge or learning; scholarly.'
      },
      {
        id: 7,
        question: 'RECALCITRANT most nearly means:',
        options: ['obedient', 'stubborn', 'flexible', 'cheerful'],
        correctAnswer: 1,
        explanation: 'Recalcitrant means stubbornly resistant to authority or control.'
      },
      {
        id: 8,
        question: 'LOQUACIOUS most nearly means:',
        options: ['quiet', 'talkative', 'shy', 'angry'],
        correctAnswer: 1,
        explanation: 'Loquacious means very talkative; garrulous.'
      },
      {
        id: 9,
        question: 'UBIQUITOUS most nearly means:',
        options: ['rare', 'everywhere', 'hidden', 'ancient'],
        correctAnswer: 1,
        explanation: 'Ubiquitous means present or appearing everywhere; omnipresent.'
      },
      {
        id: 10,
        question: 'AUSPICIOUS most nearly means:',
        options: ['unlucky', 'favorable', 'doubtful', 'difficult'],
        correctAnswer: 1,
        explanation: 'Auspicious means showing signs that promise success; favorable.'
      }
    ]
  },
  'sat-math-test': {
    id: 'sat-math-test',
    title: 'SAT Math Practice Test',
    category: 'sat',
    difficulty: 'Intermediate',
    duration: '35 minutes',
    totalQuestions: 10,
    questions: [
      {
        id: 1,
        question: 'If 2x + 5 = 15, what is the value of x?',
        options: ['3', '5', '7', '10'],
        correctAnswer: 1,
        explanation: '2x + 5 = 15. Subtract 5: 2x = 10. Divide by 2: x = 5.'
      },
      {
        id: 2,
        question: 'What is 30% of 80?',
        options: ['18', '20', '24', '28'],
        correctAnswer: 2,
        explanation: '30% of 80 = 0.30 × 80 = 24.'
      },
      {
        id: 3,
        question: 'If a circle has a radius of 4, what is its area? (Use π ≈ 3.14)',
        options: ['12.56', '25.12', '50.24', '100.48'],
        correctAnswer: 2,
        explanation: 'Area = πr² = 3.14 × 4² = 3.14 × 16 = 50.24.'
      },
      {
        id: 4,
        question: 'Solve for y: 3y - 7 = 11',
        options: ['4', '6', '8', '10'],
        correctAnswer: 1,
        explanation: '3y - 7 = 11. Add 7: 3y = 18. Divide by 3: y = 6.'
      },
      {
        id: 5,
        question: 'What is the slope of a line passing through points (2, 3) and (6, 11)?',
        options: ['1', '2', '3', '4'],
        correctAnswer: 1,
        explanation: 'Slope = (y₂ - y₁)/(x₂ - x₁) = (11 - 3)/(6 - 2) = 8/4 = 2.'
      },
      {
        id: 6,
        question: 'If x² = 49, what are the possible values of x?',
        options: ['7 only', '-7 only', '7 or -7', '49 or -49'],
        correctAnswer: 2,
        explanation: 'x² = 49 means x = √49 or x = -√49, so x = 7 or x = -7.'
      },
      {
        id: 7,
        question: 'A rectangle has length 10 and width 6. What is its perimeter?',
        options: ['16', '28', '32', '60'],
        correctAnswer: 2,
        explanation: 'Perimeter = 2(length + width) = 2(10 + 6) = 2(16) = 32.'
      },
      {
        id: 8,
        question: 'What is the value of 2³ + 3²?',
        options: ['13', '15', '17', '19'],
        correctAnswer: 2,
        explanation: '2³ + 3² = 8 + 9 = 17.'
      },
      {
        id: 9,
        question: 'If f(x) = 2x + 3, what is f(5)?',
        options: ['10', '11', '12', '13'],
        correctAnswer: 3,
        explanation: 'f(5) = 2(5) + 3 = 10 + 3 = 13.'
      },
      {
        id: 10,
        question: 'What is the median of the set: 3, 7, 9, 12, 15?',
        options: ['7', '9', '10', '12'],
        correctAnswer: 1,
        explanation: 'The median is the middle value when ordered: 3, 7, 9, 12, 15. Middle = 9.'
      }
    ]
  },
  // ========== ADDITIONAL SAT TESTS ==========
  'sat-reading-practice': { id: 'sat-reading-practice', title: 'SAT Reading Comprehension', category: 'sat', difficulty: 'Intermediate', totalQuestions: 6, questions: [
    { id: 1, question: 'What is the primary purpose of a topic sentence?', options: ['To conclude', 'To introduce the main idea', 'To provide evidence', 'To summarize'], correctAnswer: 1, explanation: 'A topic sentence introduces the paragraph\'s main idea.' },
    { id: 2, question: 'Context clues help readers:', options: ['Confuse meaning', 'Determine word meanings from surrounding text', 'Skip passages', 'Write summaries'], correctAnswer: 1, explanation: 'Context clues provide hints about unfamiliar words through surrounding text.' },
    { id: 3, question: 'Inference in reading means:', options: ['Reading literally only', 'Drawing logical conclusions from evidence', 'Memorizing facts', 'Skipping difficult parts'], correctAnswer: 1, explanation: 'Inference involves reasoning beyond explicitly stated information.' },
    { id: 4, question: 'The tone of a passage refers to:', options: ['Sentence length', 'Author\'s attitude toward the subject', 'Number of paragraphs', 'Reading difficulty'], correctAnswer: 1, explanation: 'Tone reflects how the author feels about the topic.' },
    { id: 5, question: 'Which is a primary source?', options: ['A history textbook', 'An encyclopedia entry', 'An original diary from the period', 'A modern documentary'], correctAnswer: 2, explanation: 'Primary sources are original documents from the time being studied.' },
    { id: 6, question: 'To synthesize information means to:', options: ['Copy text exactly', 'Combine ideas from multiple sources', 'Delete unnecessary content', 'Write a catchy title'], correctAnswer: 1, explanation: 'Synthesizing combines information from various sources to create new understanding.' }
  ]},
  'sat-writing-practice': { id: 'sat-writing-practice', title: 'SAT Writing & Language', category: 'sat', difficulty: 'Intermediate', totalQuestions: 6, questions: [
    { id: 1, question: 'Which shows correct subject-verb agreement?', options: ['The list of items are on the table', 'The list of items is on the table', 'The list of items were on the table', 'The list of items be on the table'], correctAnswer: 1, explanation: '"List" is singular, so it requires the singular verb "is".' },
    { id: 2, question: 'Identify correct comma usage:', options: ['After eating the students went to class', 'After eating, the students went to class', 'After, eating the students went', 'After eating the students, went'], correctAnswer: 1, explanation: 'A comma is needed after an introductory phrase.' },
    { id: 3, question: 'Complete: "_____ going to the store."', options: ['Their', 'There', 'They\'re', 'Thier'], correctAnswer: 2, explanation: '"They\'re" is the contraction for "they are".' },
    { id: 4, question: 'Which sentence uses active voice?', options: ['The ball was thrown by Sarah', 'Sarah threw the ball', 'The ball was being thrown', 'The ball had been thrown'], correctAnswer: 1, explanation: 'In active voice, the subject performs the action directly.' },
    { id: 5, question: 'Which is a run-on sentence?', options: ['I went to the store. I bought milk.', 'I went to the store; I bought milk.', 'I went to the store I bought milk.', 'I went to the store, and I bought milk.'], correctAnswer: 2, explanation: 'A run-on sentence lacks proper punctuation between independent clauses.' },
    { id: 6, question: 'Which uses an apostrophe correctly?', options: ['The dogs toy is lost', 'The dog\'s toy is lost', 'The dogs\' toy is lost', 'The dogs toy\'s is lost'], correctAnswer: 1, explanation: 'An apostrophe before "s" shows singular possession.' }
  ]}
};

// Extend testQuestions with additional section-based tests
Object.assign(testQuestions, {
  // IELTS Section Tests
  'ielts-reading-practice': { id: 'ielts-reading-practice', title: 'IELTS Reading Practice', category: 'ielts', difficulty: 'Intermediate', totalQuestions: 5, questions: [
    { id: 1, question: 'Skimming a text means:', options: ['Reading every word carefully', 'Quickly reading for main ideas', 'Translating to another language', 'Memorizing content'], correctAnswer: 1, explanation: 'Skimming involves quickly reading to grasp main ideas, not details.' },
    { id: 2, question: 'Scanning is used to:', options: ['Understand everything', 'Find specific information quickly', 'Read word by word', 'Guess meanings'], correctAnswer: 1, explanation: 'Scanning helps locate specific information without reading everything.' },
    { id: 3, question: 'In IELTS Reading, True/False/Not Given questions test:', options: ['Grammar knowledge', 'Understanding of stated vs unstated information', 'Vocabulary only', 'Writing skills'], correctAnswer: 1, explanation: 'These questions distinguish between what is stated, contradicted, or not mentioned.' },
    { id: 4, question: 'Headings matching questions require:', options: ['Translating paragraphs', 'Identifying main ideas of paragraphs', 'Counting words', 'Memorizing text'], correctAnswer: 1, explanation: 'Matching headings tests ability to identify paragraph main ideas.' },
    { id: 5, question: 'Academic IELTS Reading passages are:', options: ['From newspapers only', 'From academic books, journals, and magazines', 'From novels', 'From social media'], correctAnswer: 1, explanation: 'Academic Reading uses texts from scholarly sources.' }
  ]},
  'ielts-writing-practice': { id: 'ielts-writing-practice', title: 'IELTS Writing Skills', category: 'ielts', difficulty: 'Intermediate', totalQuestions: 5, questions: [
    { id: 1, question: 'Task 2 minimum word count is:', options: ['150 words', '200 words', '250 words', '300 words'], correctAnswer: 2, explanation: 'Task 2 requires at least 250 words.' },
    { id: 2, question: 'Which linking word shows contrast?', options: ['Furthermore', 'However', 'Therefore', 'Moreover'], correctAnswer: 1, explanation: '"However" indicates contrast between ideas.' },
    { id: 3, question: 'Paraphrasing the question means:', options: ['Copying it exactly', 'Rewriting in your own words', 'Ignoring it', 'Answering differently'], correctAnswer: 1, explanation: 'Paraphrasing expresses the same idea using different words.' },
    { id: 4, question: 'Task Achievement measures:', options: ['Grammar only', 'How well you answer the question', 'Handwriting', 'Word count only'], correctAnswer: 1, explanation: 'Task Achievement assesses how fully you address the task.' },
    { id: 5, question: 'Academic writing should avoid:', options: ['Complex sentences', 'Formal vocabulary', 'Contractions (don\'t, can\'t)', 'Topic sentences'], correctAnswer: 2, explanation: 'Academic writing requires formal language without contractions.' }
  ]},
  'ielts-listening-practice': { id: 'ielts-listening-practice', title: 'IELTS Listening Skills', category: 'ielts', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'IELTS Listening has how many sections?', options: ['2', '3', '4', '5'], correctAnswer: 2, explanation: 'IELTS Listening consists of 4 sections.' },
    { id: 2, question: 'You hear the audio:', options: ['Three times', 'Twice', 'Once only', 'As many times as needed'], correctAnswer: 2, explanation: 'Each recording is played only once in the actual test.' },
    { id: 3, question: 'Predictions help because:', options: ['You can guess answers', 'You know what information to listen for', 'You don\'t need to listen', 'You can skip sections'], correctAnswer: 1, explanation: 'Predicting helps focus on relevant information while listening.' },
    { id: 4, question: 'Spelling and grammar:', options: ['Don\'t matter', 'Are assessed in your answers', 'Only matter in Writing', 'Are ignored'], correctAnswer: 1, explanation: 'Spelling and grammar mistakes lose marks even in Listening.' },
    { id: 5, question: 'Distractors in Listening are:', options: ['Helpful hints', 'Incorrect information mentioned to confuse', 'Section titles', 'Instructions'], correctAnswer: 1, explanation: 'Distractors are incorrect options mentioned to test careful listening.' }
  ]},
  'ielts-speaking-practice': { id: 'ielts-speaking-practice', title: 'IELTS Speaking Skills', category: 'ielts', difficulty: 'Intermediate', totalQuestions: 5, questions: [
    { id: 1, question: 'IELTS Speaking has how many parts?', options: ['2', '3', '4', '5'], correctAnswer: 1, explanation: 'Speaking consists of 3 parts: Introduction, Long Turn, Discussion.' },
    { id: 2, question: 'Part 1 focuses on:', options: ['Complex academic topics', 'Familiar topics about yourself and daily life', 'Abstract philosophy', 'Technical subjects'], correctAnswer: 1, explanation: 'Part 1 covers familiar everyday topics and personal information.' },
    { id: 3, question: 'In Part 2, you speak for:', options: ['30 seconds', '1 minute', '1-2 minutes', '5 minutes'], correctAnswer: 2, explanation: 'Part 2 requires speaking for 1-2 minutes on a given topic.' },
    { id: 4, question: 'Fluency means:', options: ['Speaking without errors', 'Speaking smoothly without long pauses', 'Using difficult vocabulary', 'Speaking quickly'], correctAnswer: 1, explanation: 'Fluency is about smooth delivery with minimal hesitation.' },
    { id: 5, question: 'Lexical Resource assesses:', options: ['Grammar accuracy', 'Range and accuracy of vocabulary', 'Pronunciation', 'Speaking speed'], correctAnswer: 1, explanation: 'Lexical Resource evaluates vocabulary range and precision.' }
  ]},
  // GMAT Additional Tests
  'gmat-quant-practice': { id: 'gmat-quant-practice', title: 'GMAT Quantitative Reasoning', category: 'gmat', difficulty: 'Advanced', totalQuestions: 6, questions: [
    { id: 1, question: 'If x + 3 = 7, then 2x = ?', options: ['6', '8', '10', '14'], correctAnswer: 1, explanation: 'x = 4, so 2x = 8.' },
    { id: 2, question: '25% of 80 equals:', options: ['15', '20', '25', '30'], correctAnswer: 1, explanation: '25% = 1/4, so 80/4 = 20.' },
    { id: 3, question: 'If y = 2x + 1 and x = 3, then y = ?', options: ['5', '6', '7', '8'], correctAnswer: 2, explanation: 'y = 2(3) + 1 = 7.' },
    { id: 4, question: 'The prime factors of 30 are:', options: ['2, 3, 5', '3, 10', '5, 6', '2, 15'], correctAnswer: 0, explanation: '30 = 2 × 3 × 5.' },
    { id: 5, question: 'If a triangle has angles 60°, 60°, and x°, then x = ?', options: ['30', '45', '60', '90'], correctAnswer: 2, explanation: 'Triangle angles sum to 180°: 60 + 60 + 60 = 180.' },
    { id: 6, question: 'The average of 5, 10, and 15 is:', options: ['8', '10', '12', '15'], correctAnswer: 1, explanation: '(5 + 10 + 15) / 3 = 30 / 3 = 10.' }
  ]},
  'gmat-verbal-practice': { id: 'gmat-verbal-practice', title: 'GMAT Critical Reasoning', category: 'gmat', difficulty: 'Advanced', totalQuestions: 5, questions: [
    { id: 1, question: 'Which strengthens an argument?', options: ['Unrelated facts', 'Evidence supporting the conclusion', 'Alternative explanations', 'Emotional appeals'], correctAnswer: 1, explanation: 'Supporting evidence strengthens an argument.' },
    { id: 2, question: 'An assumption in an argument is:', options: ['Explicitly stated', 'An unstated belief necessary for the argument', 'The conclusion', 'Evidence given'], correctAnswer: 1, explanation: 'Assumptions are unstated beliefs required for the argument to hold.' },
    { id: 3, question: 'To weaken an argument, find evidence that:', options: ['Supports the conclusion', 'Contradicts the conclusion or premises', 'Is neutral', 'Agrees with assumptions'], correctAnswer: 1, explanation: 'Contradictory evidence weakens an argument.' },
    { id: 4, question: 'A conclusion is:', options: ['The premise', 'The main point being argued', 'Supporting evidence', 'An assumption'], correctAnswer: 1, explanation: 'The conclusion is the main claim the argument aims to prove.' },
    { id: 5, question: 'Inference questions ask you to:', options: ['State what is directly said', 'Determine what must be true based on given information', 'Disagree with the passage', 'Memorize facts'], correctAnswer: 1, explanation: 'Inferences are logical conclusions drawn from stated information.' }
  ]},
  // GRE Additional Tests
  'gre-quant-practice': { id: 'gre-quant-practice', title: 'GRE Quantitative Reasoning', category: 'gre', difficulty: 'Advanced', totalQuestions: 6, questions: [
    { id: 1, question: 'If 3x = 12, then x = ?', options: ['2', '3', '4', '5'], correctAnswer: 2, explanation: 'x = 12 / 3 = 4.' },
    { id: 2, question: 'The square root of 64 is:', options: ['6', '7', '8', '9'], correctAnswer: 2, explanation: '√64 = 8.' },
    { id: 3, question: 'If a = 5 and b = 3, then a² - b² = ?', options: ['8', '16', '25', '34'], correctAnswer: 1, explanation: '25 - 9 = 16.' },
    { id: 4, question: '40% of 50 equals:', options: ['15', '18', '20', '25'], correctAnswer: 2, explanation: '0.40 × 50 = 20.' },
    { id: 5, question: 'If x/5 = 4, then x = ?', options: ['9', '15', '20', '25'], correctAnswer: 2, explanation: 'x = 4 × 5 = 20.' },
    { id: 6, question: 'The perimeter of a square with side 6 is:', options: ['12', '18', '24', '36'], correctAnswer: 2, explanation: 'Perimeter = 4 × side = 4 × 6 = 24.' }
  ]},
  'gre-verbal-practice': { id: 'gre-verbal-practice', title: 'GRE Verbal Reasoning', category: 'gre', difficulty: 'Advanced', totalQuestions: 6, questions: [
    { id: 1, question: 'GREGARIOUS most nearly means:', options: ['Solitary', 'Sociable', 'Angry', 'Confused'], correctAnswer: 1, explanation: 'Gregarious means enjoying company; sociable.' },
    { id: 2, question: 'METICULOUS most nearly means:', options: ['Careless', 'Careful and precise', 'Quick', 'Lazy'], correctAnswer: 1, explanation: 'Meticulous means showing great attention to detail.' },
    { id: 3, question: 'VERBOSE most nearly means:', options: ['Concise', 'Wordy', 'Silent', 'Accurate'], correctAnswer: 1, explanation: 'Verbose means using more words than necessary.' },
    { id: 4, question: 'SKEPTICAL most nearly means:', options: ['Trusting', 'Doubtful', 'Happy', 'Certain'], correctAnswer: 1, explanation: 'Skeptical means having doubts or reservations.' },
    { id: 5, question: 'NOVEL as an adjective means:', options: ['A book', 'Old', 'New and unusual', 'Common'], correctAnswer: 2, explanation: 'Novel means new, original, or unusual.' },
    { id: 6, question: 'BENEVOLENT most nearly means:', options: ['Cruel', 'Kind and generous', 'Indifferent', 'Angry'], correctAnswer: 1, explanation: 'Benevolent means well-meaning and kindly.' }
  ]},
  // Selective Entry Additional Tests
  'selective-reading-practice': { id: 'selective-reading-practice', title: 'Selective Entry Reading Comprehension', category: 'selective', difficulty: 'Intermediate', totalQuestions: 5, questions: [
    { id: 1, question: 'A main idea is:', options: ['A small detail', 'The central point of a passage', 'The title', 'The last sentence'], correctAnswer: 1, explanation: 'The main idea is the central message or point of the text.' },
    { id: 2, question: 'Supporting details:', options: ['Are unimportant', 'Provide evidence for the main idea', 'Confuse the reader', 'Replace the conclusion'], correctAnswer: 1, explanation: 'Supporting details provide evidence and examples for the main idea.' },
    { id: 3, question: 'A synonym is:', options: ['An opposite word', 'A word with similar meaning', 'A nonsense word', 'A difficult word'], correctAnswer: 1, explanation: 'Synonyms are words with similar meanings.' },
    { id: 4, question: 'An antonym is:', options: ['A similar word', 'An opposite word', 'A made-up word', 'A long word'], correctAnswer: 1, explanation: 'Antonyms are words with opposite meanings.' },
    { id: 5, question: 'Cause and effect shows:', options: ['Time sequence only', 'Why something happened and what resulted', 'Character names', 'Settings'], correctAnswer: 1, explanation: 'Cause and effect explains reasons and results.' }
  ]},
  'selective-reasoning-practice': { id: 'selective-reasoning-practice', title: 'Selective Entry Logical Reasoning', category: 'selective', difficulty: 'Intermediate', totalQuestions: 5, questions: [
    { id: 1, question: 'If A > B and B > C, then:', options: ['C > A', 'A > C', 'C = A', 'Cannot determine'], correctAnswer: 1, explanation: 'Transitive property: If A > B and B > C, then A must be greater than C.' },
    { id: 2, question: 'All dogs are animals. Rex is a dog. Therefore:', options: ['Rex is not an animal', 'Rex is an animal', 'All animals are dogs', 'Rex is a cat'], correctAnswer: 1, explanation: 'If all dogs are animals and Rex is a dog, Rex must be an animal.' },
    { id: 3, question: 'A pattern goes: 5, 10, 15, 20, __. The next number is:', options: ['22', '24', '25', '30'], correctAnswer: 2, explanation: 'Pattern increases by 5 each time: 20 + 5 = 25.' },
    { id: 4, question: 'If today is Monday, what day was it 3 days ago?', options: ['Thursday', 'Friday', 'Saturday', 'Sunday'], correctAnswer: 1, explanation: 'Counting back: Sunday, Saturday, Friday.' },
    { id: 5, question: 'Which doesn\'t belong? Apple, Banana, Carrot, Orange', options: ['Apple', 'Banana', 'Carrot', 'Orange'], correctAnswer: 2, explanation: 'Carrot is a vegetable; the others are fruits.' }
  ]},
  // VCE Additional Tests  
  'vce-text-response-practice': { id: 'vce-text-response-practice', title: 'VCE Text Response Skills', category: 'vce', difficulty: 'Advanced', totalQuestions: 5, questions: [
    { id: 1, question: 'A thesis statement should:', options: ['List all quotes', 'Present your main argument', 'Summarize the plot', 'Name the author only'], correctAnswer: 1, explanation: 'A thesis presents your central argument about the text.' },
    { id: 2, question: 'TEEL stands for:', options: ['Text, Example, Evidence, Link', 'Topic, Evidence, Explanation, Link', 'Topic, Example, Essay, Literature', 'Text, Evidence, Example, Literal'], correctAnswer: 1, explanation: 'TEEL: Topic, Evidence, Explanation, Link.' },
    { id: 3, question: 'Textual evidence should:', options: ['Be irrelevant', 'Support your argument', 'Contradict your point', 'Be from any book'], correctAnswer: 1, explanation: 'Evidence must support and strengthen your argument.' },
    { id: 4, question: 'Symbolism refers to:', options: ['Literal meaning', 'Objects representing abstract ideas', 'Plot events', 'Character names'], correctAnswer: 1, explanation: 'Symbols represent deeper, abstract meanings.' },
    { id: 5, question: 'Analysis means:', options: ['Summarizing the story', 'Examining how techniques create meaning', 'Copying quotes', 'Listing events'], correctAnswer: 1, explanation: 'Analysis examines how literary techniques contribute to themes and meanings.' }
  ]},
  // EAL Tests
  'eal-reading-practice': { id: 'eal-reading-practice', title: 'EAL Reading Skills', category: 'eal', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'The main idea of a paragraph is:', options: ['The first word', 'The central point being made', 'The longest sentence', 'The last word'], correctAnswer: 1, explanation: 'The main idea is the central message of the paragraph.' },
    { id: 2, question: 'A prediction means:', options: ['Reading backwards', 'Guessing what will happen next', 'Memorizing text', 'Skipping pages'], correctAnswer: 1, explanation: 'Predicting involves using clues to guess upcoming information.' },
    { id: 3, question: 'When you don\'t know a word, you should:', options: ['Stop reading', 'Use context clues', 'Guess randomly', 'Skip the sentence'], correctAnswer: 1, explanation: 'Context clues help determine word meanings.' },
    { id: 4, question: 'A fact is:', options: ['Someone\'s opinion', 'Something that can be proven true', 'A guess', 'A feeling'], correctAnswer: 1, explanation: 'Facts are statements that can be verified as true.' },
    { id: 5, question: 'An opinion is:', options: ['Always true', 'A personal belief or view', 'A proven fact', 'Wrong'], correctAnswer: 1, explanation: 'Opinions are personal beliefs that may vary between people.' }
  ]},
  'eal-writing-practice': { id: 'eal-writing-practice', title: 'EAL Writing Skills', category: 'eal', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'A sentence must have:', options: ['Only a verb', 'A subject and a verb', 'Only adjectives', 'Five words minimum'], correctAnswer: 1, explanation: 'Every complete sentence needs at least a subject and a verb.' },
    { id: 2, question: 'A capital letter is used:', options: ['In the middle of words', 'At the start of sentences and for names', 'Only for names', 'Never'], correctAnswer: 1, explanation: 'Capitals start sentences and are used for proper nouns.' },
    { id: 3, question: 'A period (.) is used to:', options: ['Ask questions', 'End statements', 'Show excitement', 'List items'], correctAnswer: 1, explanation: 'Periods end declarative sentences (statements).' },
    { id: 4, question: 'Which is correct? "I ___ a student."', options: ['is', 'am', 'are', 'be'], correctAnswer: 1, explanation: 'Use "am" with "I": I am a student.' },
    { id: 5, question: 'Plural of "book" is:', options: ['book', 'books', 'bookes', 'bookies'], correctAnswer: 1, explanation: 'Add "s" to make most nouns plural.' }
  ]},
  'eal-grammar-practice': { id: 'eal-grammar-practice', title: 'EAL Grammar Essentials', category: 'eal', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'A noun is:', options: ['An action word', 'A person, place, or thing', 'A describing word', 'A connecting word'], correctAnswer: 1, explanation: 'Nouns name people, places, things, or ideas.' },
    { id: 2, question: 'A verb is:', options: ['A naming word', 'An action or state of being', 'A describing word', 'A place'], correctAnswer: 1, explanation: 'Verbs express actions or states of being.' },
    { id: 3, question: 'An adjective:', options: ['Names things', 'Describes nouns', 'Shows action', 'Connects ideas'], correctAnswer: 1, explanation: 'Adjectives describe or modify nouns.' },
    { id: 4, question: '"The" is:', options: ['A noun', 'A verb', 'An article', 'An adjective'], correctAnswer: 2, explanation: '"The" is a definite article used before nouns.' },
    { id: 5, question: 'Present tense of "walked" is:', options: ['walk', 'walking', 'walks', 'will walk'], correctAnswer: 0, explanation: 'Base form "walk" is present tense.' }
  ]},
  // Special Needs Tests (All FREE)
  'special-needs-reading': { id: 'special-needs-reading', title: 'Reading Comprehension Basics', category: 'special-needs', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'The title of a story tells us:', options: ['The ending', 'What the story is about', 'Who wrote it', 'How many pages'], correctAnswer: 1, explanation: 'Titles give us a clue about the story topic.' },
    { id: 2, question: 'A character is:', options: ['A person or animal in a story', 'The title', 'The setting', 'The ending'], correctAnswer: 0, explanation: 'Characters are the people or animals in the story.' },
    { id: 3, question: 'The setting is:', options: ['What happens', 'Where and when the story takes place', 'Who is in the story', 'The problem'], correctAnswer: 1, explanation: 'Setting tells us where and when the story happens.' },
    { id: 4, question: 'The plot is:', options: ['Who is in the story', 'What happens in the story', 'Where it takes place', 'The title'], correctAnswer: 1, explanation: 'Plot is the sequence of events in the story.' },
    { id: 5, question: 'The beginning of a story usually:', options: ['Solves the problem', 'Introduces characters and setting', 'Ends the story', 'Has no purpose'], correctAnswer: 1, explanation: 'Story beginnings introduce who and where.' }
  ]},
  'special-needs-math': { id: 'special-needs-math', title: 'Foundational Math Skills', category: 'special-needs', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: '5 + 3 = ?', options: ['6', '7', '8', '9'], correctAnswer: 2, explanation: 'Counting on from 5: 6, 7, 8.' },
    { id: 2, question: '10 - 4 = ?', options: ['4', '5', '6', '7'], correctAnswer: 2, explanation: 'Taking 4 away from 10 leaves 6.' },
    { id: 3, question: 'Which is bigger: 7 or 5?', options: ['5', '7', 'They are equal', 'Neither'], correctAnswer: 1, explanation: '7 is greater than 5.' },
    { id: 4, question: 'What comes next: 2, 4, 6, __?', options: ['7', '8', '9', '10'], correctAnswer: 1, explanation: 'Pattern goes up by 2 each time.' },
    { id: 5, question: 'A triangle has how many sides?', options: ['2', '3', '4', '5'], correctAnswer: 1, explanation: 'Triangles have 3 sides.' }
  ]},
  'special-needs-vocabulary': { id: 'special-needs-vocabulary', title: 'Vocabulary Practice', category: 'special-needs', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'Happy means:', options: ['Sad', 'Joyful', 'Angry', 'Tired'], correctAnswer: 1, explanation: 'Happy and joyful mean feeling good.' },
    { id: 2, question: 'Big means:', options: ['Small', 'Large', 'Tiny', 'Short'], correctAnswer: 1, explanation: 'Big and large mean the same thing.' },
    { id: 3, question: 'Fast means:', options: ['Slow', 'Quick', 'Stopped', 'Lazy'], correctAnswer: 1, explanation: 'Fast and quick both mean moving rapidly.' },
    { id: 4, question: 'Cold is the opposite of:', options: ['Cool', 'Freezing', 'Hot', 'Warm'], correctAnswer: 2, explanation: 'Cold and hot are opposites.' },
    { id: 5, question: 'Start means the same as:', options: ['Stop', 'Begin', 'End', 'Finish'], correctAnswer: 1, explanation: 'Start and begin both mean to commence.' }
  ]},
  'special-needs-reasoning': { id: 'special-needs-reasoning', title: 'Step-by-Step Reasoning', category: 'special-needs', difficulty: 'Beginner', totalQuestions: 5, questions: [
    { id: 1, question: 'If it is raining, you need a:', options: ['Swimsuit', 'Umbrella', 'Sunglasses', 'Shorts'], correctAnswer: 1, explanation: 'Umbrellas keep us dry in the rain.' },
    { id: 2, question: 'At night, the sky is:', options: ['Blue', 'Dark', 'Green', 'Yellow'], correctAnswer: 1, explanation: 'The sky appears dark at night.' },
    { id: 3, question: 'You use a pencil to:', options: ['Eat', 'Write', 'Sleep', 'Run'], correctAnswer: 1, explanation: 'Pencils are tools for writing.' },
    { id: 4, question: 'Which is a fruit?', options: ['Carrot', 'Apple', 'Bread', 'Chicken'], correctAnswer: 1, explanation: 'An apple is a type of fruit.' },
    { id: 5, question: 'What do you do when you are hungry?', options: ['Sleep', 'Eat', 'Run', 'Read'], correctAnswer: 1, explanation: 'Eating satisfies hunger.' }
  ]}
});

// ==================== SIMULATED EXAM CONFIGURATIONS ====================
// Multi-section exam simulations for realistic test practice
// Property of Winhouse Consultancy

export const simulatedExams = {
  'ielts-full-simulation': {
    id: 'ielts-full-simulation',
    title: 'IELTS Academic Full Practice Exam',
    category: 'ielts',
    description: 'Complete IELTS Academic test simulation with all 4 sections',
    duration: '165 minutes',
    sections: [
      { testId: 'ielts-listening-practice', sectionName: 'Listening', duration: '30 min' },
      { testId: 'ielts-reading-practice', sectionName: 'Reading', duration: '60 min' },
      { testId: 'ielts-writing-practice', sectionName: 'Writing', duration: '60 min' },
      { testId: 'ielts-speaking-practice', sectionName: 'Speaking', duration: '15 min' }
    ],
    instructions: [
      'This is a full IELTS Academic practice test covering all 4 sections',
      'Complete each section in order - you cannot skip ahead',
      'Take breaks between sections if needed',
      'Your overall score will be calculated at the end',
      'Review your answers in detailed feedback mode after submission'
    ]
  },
  'sat-full-simulation': {
    id: 'sat-full-simulation',
    title: 'SAT Full Practice Exam',
    category: 'sat',
    description: 'Complete SAT practice test with all sections',
    duration: '180 minutes',
    sections: [
      { testId: 'sat-reading-practice', sectionName: 'Reading', duration: '65 min' },
      { testId: 'sat-writing-practice', sectionName: 'Writing & Language', duration: '35 min' },
      { testId: 'sat-math-test', sectionName: 'Math', duration: '80 min' }
    ],
    instructions: [
      'This SAT practice test includes Reading, Writing & Language, and Math sections',
      'Complete sections in order for best exam simulation',
      'Time limits are shown for reference (not enforced in practice mode)',
      'You will receive section scores and an overall result',
      'Review incorrect answers with detailed explanations'
    ]
  },
  'gmat-full-simulation': {
    id: 'gmat-full-simulation',
    title: 'GMAT Full Practice Exam',
    category: 'gmat',
    description: 'Complete GMAT practice with Quantitative and Verbal sections',
    duration: '210 minutes',
    sections: [
      { testId: 'gmat-quant-practice', sectionName: 'Quantitative Reasoning', duration: '62 min' },
      { testId: 'gmat-data-sufficiency', sectionName: 'Data Sufficiency', duration: '62 min' },
      { testId: 'gmat-verbal-practice', sectionName: 'Verbal Reasoning', duration: '65 min' }
    ],
    instructions: [
      'This GMAT simulation includes Quantitative and Verbal sections',
      'Each section tests different reasoning skills',
      'Practice under timed conditions for best preparation',
      'Your scaled score will be calculated based on correct answers',
      'Use the review mode to understand your mistakes'
    ]
  },
  'gre-full-simulation': {
    id: 'gre-full-simulation',
    title: 'GRE Full Practice Exam',
    category: 'gre',
    description: 'Complete GRE General Test simulation',
    duration: '225 minutes',
    sections: [
      { testId: 'gre-verbal-practice', sectionName: 'Verbal Reasoning', duration: '30 min' },
      { testId: 'gre-quant-practice', sectionName: 'Quantitative Reasoning', duration: '35 min' },
      { testId: 'gre-vocabulary-test', sectionName: 'Vocabulary Skills', duration: '20 min' }
    ],
    instructions: [
      'GRE General Test practice covering Verbal and Quantitative Reasoning',
      'Complete all sections to get comprehensive performance feedback',
      'Time estimates provided for realistic practice pacing',
      'Analytical Writing section can be practiced separately',
      'Review section includes answer rationales and strategies'
    ]
  },
  'selective-full-simulation': {
    id: 'selective-full-simulation',
    title: 'Selective Entry Full Practice Exam',
    category: 'selective',
    description: 'Complete selective schools entrance test simulation',
    duration: '180 minutes',
    sections: [
      { testId: 'selective-math-practice', sectionName: 'Mathematics', duration: '60 min' },
      { testId: 'selective-reading-practice', sectionName: 'Reading Comprehension', duration: '60 min' },
      { testId: 'selective-reasoning-practice', sectionName: 'Logical Reasoning', duration: '60 min' }
    ],
    instructions: [
      'Full selective entry test covering all three assessment areas',
      'Practice all sections to identify your strengths and improvement areas',
      'Questions simulate real selective school entrance exam difficulty',
      'Detailed explanations help you learn from every question',
      'Complete the full test for the most accurate preparation experience'
    ]
  },
  'vce-english-full': {
    id: 'vce-english-full',
    title: 'VCE English Full Practice',
    category: 'vce',
    description: 'Comprehensive VCE English skills practice',
    duration: '90 minutes',
    sections: [
      { testId: 'vce-english-practice', sectionName: 'English Fundamentals', duration: '45 min' },
      { testId: 'vce-text-response-practice', sectionName: 'Text Response Skills', duration: '45 min' }
    ],
    instructions: [
      'VCE English practice covering core skills and text response',
      'Build confidence with exam-style questions',
      'Practice TEEL structure and analytical techniques',
      'Get immediate feedback on your literary analysis understanding',
      'Review mode shows detailed explanations for every question'
    ]
  },
  'eal-full-simulation': {
    id: 'eal-full-simulation',
    title: 'EAL Comprehensive Skills Test',
    category: 'eal',
    description: 'Complete English as Additional Language practice test',
    duration: '60 minutes',
    sections: [
      { testId: 'eal-reading-practice', sectionName: 'Reading Skills', duration: '20 min' },
      { testId: 'eal-writing-practice', sectionName: 'Writing Skills', duration: '20 min' },
      { testId: 'eal-grammar-practice', sectionName: 'Grammar Essentials', duration: '20 min' }
    ],
    instructions: [
      'Comprehensive EAL skills assessment covering reading, writing, and grammar',
      'Practice all core English language competencies',
      'Questions progress from basic to intermediate difficulty',
      'Detailed feedback helps strengthen your English foundation',
      'Complete all sections for comprehensive skill assessment'
    ]
  },
  'special-needs-full': {
    id: 'special-needs-full',
    title: 'Foundational Skills Assessment',
    category: 'special-needs',
    description: 'Comprehensive learning skills practice (100% FREE)',
    duration: '40 minutes',
    isPremium: false,
    sections: [
      { testId: 'special-needs-reading', sectionName: 'Reading Basics', duration: '10 min' },
      { testId: 'special-needs-math', sectionName: 'Math Skills', duration: '10 min' },
      { testId: 'special-needs-vocabulary', sectionName: 'Vocabulary', duration: '10 min' },
      { testId: 'special-needs-reasoning', sectionName: 'Reasoning', duration: '10 min' }
    ],
    instructions: [
      'This comprehensive assessment covers foundational learning skills',
      'All sections are 100% FREE and accessible',
      'Take your time with each question',
      'Questions are designed to build confidence step-by-step',
      'Review your answers to see where you did well and what to practice more'
    ]
  }
};
